import { IRawStyle } from "@bps/fluent-ui";

export const advancedSearchDialogInnerWrapperStyles: IRawStyle = {
  display: "flex",
  flexDirection: "column",
  flex: 1,
  overflow: "auto"
};
